<div
  class="page-container"
  [class.particles-visible]="particlesVisible"
  #containerRef
  (mousemove)="onMouseMove($event)"
  (mouseleave)="onMouseLeave()"
  (click)="onContainerClick($event)"
>
  <img #imgParticle src="assets/images/dart.png" class="img-particle dart-particle" alt="" />
  <img #imgParticle src="assets/images/at.png" class="img-particle at-particle" alt="" />

  <div class="card-and-dots">
    <div class="dots-layer">
      <span class="dot dot-d1"></span>
      <span class="dot dot-d2"></span>
      <span class="dot dot-d3"></span>
      <span class="dot dot-d4"></span>
      <span class="dot dot-r1"></span>
      <span class="dot dot-r2"></span>
      <span class="dot dot-r3"></span>
    </div>
    <div class="login-card-wrapper" #loginCardWrapper>
      <ng-content select="[login-card]"></ng-content>
    </div>
  </div>

  <img #imgParticle src="assets/images/letter.png" class="img-particle letter-particle" alt="" />
  <img
    #imgParticle
    src="assets/images/openLetter.png"
    class="img-particle open-letter-particle"
    alt=""
  />

  <ng-content select="[login-footer]"></ng-content>
</div>
